import React from "react";
import { connect } from "react-redux";
import SearchDoctorFilter from "./SearchDoctorFilter";
import {
  CssBaseline,
  Box,
  
  withStyles,
} from "@material-ui/core";
import { DoctorAction } from "../../../redux/actions/DoctorAction";
import SearchDoctorCardListView from "./SearchDoctorCardListView";

const useStyles = (theme) => ({
  main: {
    marginTop: theme.spacing(4),
  },
});

class DoctorSearchList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      startDateTime: this.props.startDateTime,
      showNotAvailabe: false,
      showDoctorList: false
    };
  }
  componentDidMount() {
    if(this.props.startDateTime && this.props.startDateTime.length > 0){
      this.handleSearchDoctor({startDateTime: this.props.startDateTime});
    }
  }
  // componentDidUpdate(prevProps){
  //   if (this.props.searchResult && this.state.searchResult && this.props.searchResult.length !== this.state.searchResult.length){
  //      this.setState({searchResult:this.props.searchResult});
       
  //   }
  // }

  handleDateChange(e){
    this.setState({ showDoctorList:false });
  }

  handleSearchDoctor(data) {
    var payload = {
      startDateTime: data.startDateTime,
      endDateTime: "",
    };
    this.setState({ startDateTime: data.startDateTime });
    this.setState({ showNotAvailabe: true,showDoctorList:true });
    this.props.searchDoctor(payload);
  }
  handleBookAppointment(doctorId) {
    var payload = {
      doctorId: doctorId,
      startDateTime: this.state.startDateTime,
    };
    this.props.handleBookAppointment(payload);
  }

  render() {
    const classes = this.props.classes;
    return (
      <Box
        style={{
          backgroundColor: "background.default",
        }}
      >
        <CssBaseline />

        <SearchDoctorFilter
          startDateTime = {this.props.startDateTime}
          handleSearchDoctor={(payload) => {
            this.handleSearchDoctor(payload);
          }}
          handleDateChange={(e)=>{
            if(e.target.value === this.state.startDateTime){

            }else{
              this.handleDateChange(e);
            }
          }}
          />
        {this.state.showDoctorList?
        <SearchDoctorCardListView
          doctors={this.props.searchResult}
          showBookNowBtn={true}
          showNotAvailabe={this.state.showNotAvailabe}
          handleBookAppointment={(doctorId) => {
            this.handleBookAppointment(doctorId);
          }}
        ></SearchDoctorCardListView>:null}
      </Box>
    );
  }
}

function mapStateToProps(state) {
  const searchResult = state.doctor.searchResult;
  return { searchResult };
}

const mapDispatchToProps = (dispatch) => {
  return {
    searchDoctor: (payload) => {
      dispatch(DoctorAction.searchDoctor(payload));
    },
    clearDoctorSearchResult: () => {
      dispatch(DoctorAction.clearDoctorSearchResult());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DoctorSearchList));
